import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { SearchResult } from 'src/app/interfaces/search-result';
import { ServerTypes } from 'src/app/models/servers';
import { requests } from 'src/app/models/requests';
import { finalize } from 'rxjs/operators';
import { IdType } from 'src/app/models/id-type.enum';
import { Note } from 'src/app/interfaces/note';

@Injectable()
export class SearchService {
  private targetInstance: BehaviorSubject<string> = new BehaviorSubject<string>(
    ''
  );
  private selectedTab: BehaviorSubject<string> = new BehaviorSubject<string>(
    '0'
  );
  private searchData: BehaviorSubject<SearchResult[]> = new BehaviorSubject<
    any
  >([]);
  private searchHistory: ReplaySubject<string> = new ReplaySubject<string>(10);
  private searchInProgress: BehaviorSubject<boolean> = new BehaviorSubject<
    boolean
  >(false);
  public searchData$: Observable<any>;
  public searchHistory$: Observable<string>;
  public targetInstance$: Observable<string>;
  public searchInProgress$: Observable<boolean>;
  public selectedTab$: Observable<string>;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.searchData$ = this.searchData.asObservable();
    this.searchHistory$ = this.searchHistory.asObservable();
    this.targetInstance$ = this.targetInstance.asObservable();
    this.searchInProgress$ = this.searchInProgress.asObservable();
    this.selectedTab$ = this.selectedTab.asObservable();
  }

  public updateInstance(instance: string): void {
    this.targetInstance.next(instance);
  }

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.boapi);
  }

  public get instance(): string {
    return this.targetInstance.value;
  }

  public get selectedTabId(): string {
    return this.selectedTab.value;
  }

  public search(param): Observable<SearchResult[]> {
    this.selectedTab.next('0');
    this.searchInProgress.next(true);
    const params = new HttpParams().set('query', param.trim());
    return this.http
      .get<SearchResult[]>(`${this.url}${requests.search}` , {
        params: params,
      })
      .pipe(finalize(() => this.searchInProgress.next(false)));
  }

  public setSearchData(data: SearchResult[]): void {
    this.searchData.next(data);
  }

  public updateHistory(query: string): void {
    this.searchHistory.next(query);
  }

  public updateTabSelection(id: string) {
    this.selectedTab.next(id);
  }
}
